import { render, staticRenderFns } from "./EmailPDF.vue?vue&type=template&id=5b37d8e7"
import script from "./EmailPDF.vue?vue&type=script&lang=js"
export * from "./EmailPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports